import styled, { css, IFalconTheme, Scale, StyledComponent } from '@se-admin/falcon';

export const BookingDetailsDatesArrowWrapper: StyledComponent<'div', IFalconTheme> = styled('div')`
  display: flex;
  width: 25%;
  margin-right: ${Scale.m};
`;

export const BookingDetailsDatesArrowLine: StyledComponent<'span', IFalconTheme> = styled('span')(
  ({ theme }: { theme: IFalconTheme }) => {
    return css`
      width: 100%;
      border-bottom: 1px solid ${theme.color.grey60};
      margin-bottom: 3px;
    `;
  }
);

export const BookingDetailsDatesArrowHead: StyledComponent<'span', IFalconTheme> = styled('span')(
  ({ theme }: { theme: IFalconTheme }) => {
    return css`
      border-top: 3px solid transparent;
      border-bottom: 3px solid transparent;
      border-left: 8px solid ${theme.color.grey60};
    `;
  }
);
